<!--协同备课学科统计图-->
<template>
    <div class="my-charts">
        <div id="xl_echarts" style="margin-top: -20px;" ></div>
    </div>
</template>


<script>
import * as echarts from "echarts";


export default {
    name: "xlEcharts",
    props: {
        id:{
            type: String,
            default:"xl_echarts"
        },
        countList1:{
            type: Array,
            default:[]
        },
        countList2:{
            type: Array,
            default:[]
        },
    },
    watch:{},
    data() {
        return {
            barChart: null, // 柱状图
            chartOption:{
                tooltip: {
                    trigger: 'item'
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        interval:0,
                        rotate:0,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ffffff',
                            width: 1, //这里是为了突出显示加上的
                        }
                    },
                    data: ['本科以下', '大学本科', '硕士研究生', '博士研究生', '其他']
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#ffffff',
                            width: 1, //这里是为了突出显示加上的
                        }
                    },
                },
                series: [
                    {
                        name: '男',
                        type: 'bar',
                        color: [
                            '#a8e9e1',
                        ],
                        data: []
                    },
                    {
                        name: '女',
                        type: 'bar',
                        color: [
                            '#f6d0a9',
                        ],
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.barChart = echarts.init(document.getElementById('xl_echarts'));
            this.chartOption.series[0].data = this.countList1;
            this.chartOption.series[1].data = this.countList2;
            this.barChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    flex-direction: column;
    padding: 0 0 0 0;
    div {
        width: 100%!important;
        height: calc(50vh - 120px);
    }
}
</style>